import axios from 'axios';

const getMunicipiosPage = params => axios.get('/open/municipios/page', { params });

export default {
  getMunicipiosPage,
};
